<div class="container">
    <div class="heading-section">
        <h2>Product Details</h2>
    </div>
    <div class="row" *ngIf="products">
        <div class="col-md-6">
            <div class="item">
                <img class="img-fluid" src="{{ products.image }}" />
          </div>
        </div>
        <div class="col-md-6 mb-5">
            <div class="product-dtl">
                <div class="product-info">
                    <div class="product-name pb-2">{{ products.title }}</div>
                    <div class="reviews-counter">
                       
                    </div>
                    <div class="d-flex ">
                        <h4 class="product-price rating mb-0"><i class="fa fa-star" aria-hidden="true"></i> {{products.rating.rate}}</h4>
                        <h4 class="product-price count mb-0 ml-3 px-3">{{products.rating.count}} Reviews</h4> 
                    </div>
                    <div class="product-price-discount price pt-5 pb-4"><span>₹{{ products.price }}</span></div>
                </div>
                <p>{{ products.description }}</p>
                <div class="row">
                    <div class="col-md-6">
                        <label for="size">Size</label>
                        <select id="size" name="size" class="form-control">
                            <option>S</option>
                            <option>M</option>
                            <option>L</option>
                            <option>XL</option>
                        </select>
                    </div>
                </div>
                <div class="product-count">
                    <label for="size">Quantity</label>
                    <form action="#" class="display-flex py-2">
                        <div class="qtyminus" (click)="reduceCount()">-</div>
                        <input type="text" name="quantity" [(ngModel)]="productCount" value="1" class="qty">
                        <div class="qtyplus" (click)="increaseCount()">+</div>
                    </form>
                    <button (click)="addCart(products)" mat-button class="round-black-btn">{{ checkCart(products) }}</button>
                </div>
            </div>
        </div>
    </div>
    
</div>


<div *ngIf="!products">
    <ngx-spinner size="medium" type="ball-fussion"></ngx-spinner>
</div>